import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { UserCompany, UserProfiles } from '@shared/models';
import { StorageService } from '../services/storage/storage.service';

export const RoleGuard = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const allowedRoles: UserProfiles[] | undefined = route.data['allowedRoles'];
  const allowedCompanies : UserCompany[] | undefined = route.data['allowedCompany']

  if (!allowedRoles) {
    console.log(
      'The value of allowedRoles is undefined, which means no role restrictions have been defined. Access is allowed for any user.'
    );
    return true;
  }

  const storageService = inject(StorageService);
  const user = storageService.getUser();

  if (user && allowedRoles.includes(user.profile)) {
    if(user.profile === UserProfiles.SUPERADMIN){
      return true
    }
    if (allowedCompanies) {
      if (
        user.company &&
        allowedCompanies.includes(user.company as UserCompany)
      ) {
          return true;
        } 
    } else {
      
      return true;
    }
  }

  const router = inject(Router);
  router.navigate(['/dashboard']);
  return false;
};
